export default __webpack_public_path__ + "static/media/p6.746cbab8.jpg";